module.exports = __webpack_public_path__ + "img/game_phone_id.edaacc95.png";